import React from 'react';

import "./ArchivarMasivo.css"

const BarraArchivar = ({ total, onArchivar, onLimpiar }) => (
    <div className='barra_archivar'>
        <p className='texto_barra_archivar'>
            {total} solicitud{total === 1 ? '' : 'es'} seleccionada{total === 1 ? '' : 's'}
        </p>
        <button type="button" className="boton_admin boton_admin_secundario" onClick={onLimpiar}>
            Quitar selección
        </button>
        <button type="button" className="boton_admin" onClick={onArchivar}>
            Archivar seleccionadas
        </button>
    </div>
);

export default BarraArchivar;
